/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} finish`)
};

const es_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} llegada`)
};

const de_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} Ziel`)
};

const nl_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} finish`)
};

const fr_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} arrivée`)
};

const it_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} arrivo`)
};

const pt_br2_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} chegada`)
};

const pt_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} chegada`)
};

const ja_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} 完走`)
};

const zh_f1_stats_pill_finish = /** @type {(inputs: { value: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`P${i?.value} 完赛`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ value: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_pill_finish = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_pill_finish(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_pill_finish", locale)
	if (locale === "en") return en_f1_stats_pill_finish(inputs)
	if (locale === "es") return es_f1_stats_pill_finish(inputs)
	if (locale === "de") return de_f1_stats_pill_finish(inputs)
	if (locale === "nl") return nl_f1_stats_pill_finish(inputs)
	if (locale === "fr") return fr_f1_stats_pill_finish(inputs)
	if (locale === "it") return it_f1_stats_pill_finish(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_pill_finish(inputs)
	if (locale === "pt") return pt_f1_stats_pill_finish(inputs)
	if (locale === "ja") return ja_f1_stats_pill_finish(inputs)
	return zh_f1_stats_pill_finish(inputs)
};